import { fetchLastCallerSubscription } from './fetchLastCallerSubscription';

export const fetchSupervisorRetentionMembershipPrice = async (phoneNumber: string): Promise<number> => {
  const lastSubscription = await fetchLastCallerSubscription(phoneNumber);
  const amount = lastSubscription?.planAmount;

  if (amount == null) {
    throw new Error('No plan found for this caller');
  }
  if (!(amount > 0)) {
    throw new Error('Plan price is $0');
  }

  return amount;
};
